import { requireAnyOrgPermission, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { UserState } from '@juvare/platform-sdk-react/types';

export function allowAccessToDocuments(userState?: UserState): boolean {
    return requireAnyOrgPermission(userState, 'manage-documents', 'view-documents');
}

export function allowAccessToReports(userState?: UserState): boolean {
    return requireAnyOrgPermission(userState, 'run-reports');
}

export function allowUserSendMessages(userState?: UserState): boolean {
    return requireAnyOrgPermission(userState, 'view-and-message-members', 'create-notifications');
}

export function allowManageNotification(userState?: UserState): boolean {
    return requireAnySystemPermission(userState, 'manage-notifications');
}
